(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-components/assets/javascripts/reductions.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-components/assets/javascripts/reductions.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const Coupon = svs.components.tipsen.couponComponents.Coupon;
const useCouponContext = svs.components.tipsen.couponComponents.useCouponContext;
const selectReduction = svs.components.tipsen.engine.selectors.engineSelectors.selectReduction;
const selectReductionSelectionsForEvent = svs.components.tipsen.engine.selectors.couponSelectors.selectReductionSelectionsForEvent;
const toggleReduction = svs.components.tipsen.engine.actions.toggleReduction;
const Checkbox = svs.ui.reactForm.Checkbox;
const Reduction = _ref => {
  let className = _ref.className,
    onClick = _ref.onClick,
    isSelected = _ref.isSelected,
    value = _ref.value,
    id = _ref.id,
    disabled = _ref.disabled,
    labelMap = _ref.labelMap;
  const label = labelMap[value];
  const classNames = ['pg_reduction'];
  if (className) {
    classNames.push(className);
  }
  const handleOnChange = () => {
    onClick(value);
  };
  return React.createElement(Checkbox, {
    checked: isSelected,
    className: "".concat(classNames.join(' ')),
    disabled: disabled,
    id: id,
    name: id,
    onChange: handleOnChange,
    value: value
  }, label);
};
const Reductions = _ref2 => {
  let _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    eventNumber = _ref2.eventNumber,
    labelMap = _ref2.labelMap;
  const _useCouponContext = useCouponContext(),
    couponId = _useCouponContext.couponId;
  const dispatch = useDispatch();
  const reductionValues = useSelector(state => selectReduction(state));
  const selectedReductions = useSelector(state => selectReductionSelectionsForEvent(state, couponId, eventNumber));
  const unselectedReductions = reductionValues.filter(reduction => !selectedReductions.includes(reduction));
  const handleClick = reduction => {
    dispatch(toggleReduction({
      couponId,
      eventNumber,
      reduction
    }));
  };
  return reductionValues.map(reduction => React.createElement(Reduction, {
    className: className,
    disabled: unselectedReductions.length === 1 && unselectedReductions.includes(reduction),
    id: "reduction_".concat(eventNumber, "_").concat(reduction),
    isSelected: selectedReductions.includes(reduction),
    key: reduction,
    labelMap: labelMap,
    onClick: handleClick,
    value: reduction
  }));
};
Coupon.Reductions = Reductions;

 })(window);